import { Dialog, styled } from '@nextiva/next-ui-components';
import { pxToRem } from 'utils/pxToRemConverter';

export const DialogStyles = styled(Dialog)`
  .MuiButtonBase-root {
    text-transform: initial;
    height: 27px;
    font-size: ${pxToRem('14px')};
    font-family: Lato, sans-serif;
    letter-spacing: 0.4px;
  }

  .MuiButton-label {
    height: 27px;
    font-family: Lato, sans-serif;
    font-weight: 700;
  }

  .m-dialog {
    width: 386px;
    min-height: 200px;
    &__header {
      height: 70px;
      &__text {
        display: inline-block;
        padding-top: 24px;
        padding-bottom: 24px;
        padding-left: 21px;
      }
      &.error {
        background-color: #e06969;
        color: white;
      }
      &.info {
        background-color: #005fec;
        color: white;
      }
    }
    &__content {
      display: block;
      min-height: 120px;
      padding: 21px;
    }
    &__action-bar {
      display: block;
      padding-right: 21px;
      padding-bottom: 21px;
      padding-left: 21px;
      &__button {
        background-color: #e0e0e0;
        border-radius: 4px !important;
        min-width: 114px !important;
        height: 40px;
        box-shadow: none;
        padding: 0.75rem !important;
        &:hover {
          background-color: #d5d5d5;
          box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
            0px 4px 5px 0px rgba(0, 0, 0, 0.14),
            0px 1px 10px 0px rgba(0, 0, 0, 0.12);
        }
        &.error {
          background-color: #e06969;
          color: white;
          &:hover {
            background-color: #e06969;
          }
        }
        &.info {
          background-color: #005fec;
          color: white;
          &:hover {
            background-color: #005fec;
            box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
              0px 4px 5px 0px rgba(0, 0, 0, 0.14),
              0px 1px 10px 0px rgba(0, 0, 0, 0.12);
          }
        }
      }
      &__circular-progress {
        margin-top: 3px;
      }
    }

    .MuiCircularProgress-colorPrimary {
      color: #009fe0;
    }
  }
`;
